import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@mui+material@5.16.4_@emotion+react@11.13.0_@types+react@19.1.6_react@19.1.0__@emotion+_5b40b4fc0812efc5d9eaeae978723ffd/node_modules/@mui/material/Button/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@core/components/scroll-to-top/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/app/src/@core/contexts/settingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@layouts/components/vertical/LayoutContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@layouts/components/vertical/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@layouts/LayoutWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/@layouts/styles/vertical/StyledContentWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VerticalNavProvider"] */ "/app/src/@menu/contexts/verticalNavContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AuthBootstrapper.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ClientLocalizationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/vertical/NavbarContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/vertical/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/NotificationEventBridge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotiStackProvider"] */ "/app/src/components/Notistack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/permission/UserRoleChangeNotification.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SpinnerLoading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/theme/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/hocs/AuthGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["makeQueryClient","getQueryClient"] */ "/app/src/libs/react-query/get-query-client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/libs/react-query/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/redux-store/ReduxProvider.tsx");
